import Full from './full.vue';
import MobFull from '@rebuild/materials/shared/contact_information/mob-full.vue';

export const componentMap = {
	full: Full,
	'mob-full': MobFull
}; 